import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Dynamic SEO/OpenGraph tags. Updates document head as photographer settings load.
 * Falls back to sensible defaults declared in public/index.html.
 */
const Seo = ({ photographerName, tagline, bio, heroImage, url }) => {
  const title = photographerName
    ? `${photographerName} — ${tagline || 'Photography Portfolio'}`
    : 'Photography Portfolio';

  const description = bio
    ? bio.slice(0, 180)
    : (tagline || 'Bold & artistic photography portfolio — events, portraits, landscapes, commercial & fine art.');

  const image = 'https://static.prod-images.emergentagent.com/jobs/83d6d465-4c12-44fe-91ac-a6799fb7b36a/images/f5446bec9214a6e7a2d405d7d5cd72c65bab545ea507d0b38679561a593739ee.jpeg';
  const pageUrl = url || (typeof window !== 'undefined' ? window.location.href : '');

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {pageUrl && <meta property="og:url" content={pageUrl} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: photographerName || 'Photographer',
          jobTitle: 'Photographer',
          description,
          image,
          url: pageUrl,
        })}
      </script>
    </Helmet>
  );
};

export default Seo;
